import React, { useState } from 'react'

import { makeStyles } from '@material-ui/core/styles'
import {
  InputLabel,
  MenuItem,
  Select,
  Button,
  FormControl
} from '@material-ui/core'

import { isUserDimension } from '../../../utils/configQueries'
import { t } from '../../../utils/languages'

const orderMembers = (members) => {
  return members.sort((a, b) => (a.order > b.order ? 1 : -1))
}
const getDefaultValue = ({ id, members }) => {
  const copyMembers = [...members]

  const currentYear = new Date().getFullYear()

  // lowest order by default or year
  if (id === 29117) {
    const getCurrentYear = copyMembers.find(
      ({ name }) => name === currentYear.toString()
    )
    return getCurrentYear
      ? getCurrentYear
      : orderMembers(copyMembers)[copyMembers.length - 1]
  } else {
    return orderMembers(copyMembers)[0]
  }
}

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    width: '96%',
    height: 46,
    backgroundColor: '#ffffff'
  },
  button: {
    width: 120,
    height: 40,
    marginLeft: 7,
    backgroundColor: '#244e60',
    color: '#ffffff',
    fontSize: 15,
    display: 'block',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#244e60'
    }
  }
}))

export const Dimension = ({ id, name, members, onChange, defaultValues }) => {
  const classes = useStyles()

  const handleChange = ({ target: { value } }) => {
    setData(value)
    onChange(id, value)
  }

  const defaultValue = defaultValues
    ? defaultValues[id === 79515 ? 'idCitiesDepualc' : id]
    : getDefaultValue({ id, members }).id

  const [data, setData] = useState(defaultValue)
  return (
    <FormControl className={classes.formControl}>
      <InputLabel
        id={id}
        style={{
          maxWidth: '100%',
          fontSize: 20,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis'
        }}
      >
        {name}
      </InputLabel>
      <Select
        style={{ fontSize: 15 }}
        value={data}
        labelId={id.toString()}
        onChange={handleChange}
      >
        {members.map(({ id: key, name: label }) => (
          <MenuItem key={key} value={key}>
            {label}
          </MenuItem>
        ))}
      </Select>
      <br />
    </FormControl>
  )
}

export const Dimensions = ({ children, onAddLayer, defaultValues }) => {
  const classes = useStyles()
  const citiesDepualc = {
    name: 'Desagregación territorial',
    members: [
      {
        id: 'dam_depualc',
        name: 'División administrativa mayor'
      },
      {
        id: 'cities_depualc',
        name: 'Ciudades'
      }
    ]
  }

  let defaultMembers = defaultValues ? defaultValues : {}
  !defaultValues &&
    children
      .filter(({ id }) => isUserDimension({ dimensionId: id }))
      .map(({ id, members }) => {
        // 79515:indicators of cities_depualc are excluded
        if (id !== 79515) {
          const value = getDefaultValue({ id, members }).id
          return { [id]: value }
        } else {
          return {
            idCitiesDepualc: citiesDepualc.members[1].id
          }
        }
      })
      .forEach((mem) => (defaultMembers = { ...mem, ...defaultMembers }))

  const [values, setValues] = useState(defaultMembers)

  const handleDimensionChange = (id, value) => {
    // 79515:indicators of cities_depualc are excluded
    if (id !== 79515) {
      setValues({
        ...values,
        [id]: value
      })
    } else {
      setValues({
        ...values,
        idCitiesDepualc: value
      })
    }
  }

  return (
    <>
      {children
        .filter(({ id }) => isUserDimension({ dimensionId: id }))
        .map(({ id, name, members }) => (
          <Dimension
            key={id}
            id={id}
            defaultValues={defaultValues}
            name={id === 79515 ? citiesDepualc.name : name}
            members={id === 79515 ? citiesDepualc.members : members}
            onChange={handleDimensionChange}
          />
        ))}
      <Button className={classes.button} onClick={() => onAddLayer(values)}>
        {t('Agregar capa')}
      </Button>
    </>
  )
}
